/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboundOutBoundPicVo
 */
export interface InboundOutBoundPicVo {
    /**
     * 图片url
     * @type {string}
     * @memberof InboundOutBoundPicVo
     */
    imgUrl?: string;
    /**
     * 员工id
     * @type {number}
     * @memberof InboundOutBoundPicVo
     */
    staffId?: number;
    /**
     * 员工姓名
     * @type {string}
     * @memberof InboundOutBoundPicVo
     */
    staffName?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof InboundOutBoundPicVo
     */
    createTime?: string;
}

/**
 * Check if a given object implements the InboundOutBoundPicVo interface.
 */
export function instanceOfInboundOutBoundPicVo(value: object): value is InboundOutBoundPicVo {
    return true;
}

export function InboundOutBoundPicVoFromJSON(json: any): InboundOutBoundPicVo {
    return InboundOutBoundPicVoFromJSONTyped(json, false);
}

export function InboundOutBoundPicVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundOutBoundPicVo {
    if (json == null) {
        return json;
    }
    return {
        
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'staffId': json['staffId'] == null ? undefined : json['staffId'],
        'staffName': json['staffName'] == null ? undefined : json['staffName'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function InboundOutBoundPicVoToJSON(json: any): InboundOutBoundPicVo {
    return InboundOutBoundPicVoToJSONTyped(json, false);
}

export function InboundOutBoundPicVoToJSONTyped(value?: InboundOutBoundPicVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'imgUrl': value['imgUrl'],
        'staffId': value['staffId'],
        'staffName': value['staffName'],
        'createTime': value['createTime'],
    };
}

